module.exports = __webpack_public_path__ + "media/images/emblems/Sils_i_E_Segl_wappen-99515f4b4b65257c5ba4feae7b28b528.svg";